/* BEYO Reservation (v3) */
(() => {
  // global storage for section-scoped variant maps
  window.BEYO_VMAP = window.BEYO_VMAP || {};

  function pad(n){ return String(n).padStart(2,'0'); }
  function ymd(d){ return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`; }
  function toLocalIso(dateStr, timeStr){ return new Date(`${dateStr}T${timeStr}`); }

  function showToast(message){
    const t = document.createElement('div');
    t.className = 'beyo2-toast';
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add('show'));
    setTimeout(() => {
      t.classList.remove('show');
      setTimeout(() => t.remove(), 220);
    }, 5000);
  }

  function initModal(modal){
    if (!modal || modal.dataset.inited === '1') return;
    modal.dataset.inited = '1';

    const sectionId = modal.dataset.sectionId || '';
    const API_BASE  = modal.dataset.api || '';
    const LANG      = modal.dataset.lang || 'en';
    const productId = modal.dataset.productId || '';

    const btn = document.getElementById(`beyo-reserve-btn-${sectionId}`);
    const datesWrap = modal.querySelector('[data-dates]');
    const slotsList = modal.querySelector('[data-slots-list]');
    const emptyEl   = modal.querySelector('[data-empty]');
    const confirmBtn= modal.querySelector('[data-confirm]');
    const msgEl     = modal.querySelector('[data-msg]');
    const confirmLabel = confirmBtn?.querySelector('.beyo2-confirm-label');

    const sumWhenEl  = modal.querySelector('[data-summary-when]');
    const sumDateEl  = modal.querySelector('[data-summary-date]');
    const sumTimeEl  = modal.querySelector('[data-summary-time]');


    const helpBtn   = modal.querySelector('.beyo2-help');
    const helpPop   = modal.querySelector('[data-help-pop]');
    const helpClose = modal.querySelector('.beyo2-help-close');

    const optionInPerson = modal.querySelector('.beyo2-method[data-option="inperson"]');
    const optionVideo    = modal.querySelector('.beyo2-method[data-option="video"]');
    const optionSimple   = modal.querySelector('.beyo2-method[data-option="simple"]');

    const sumTypeEl   = modal.querySelector('[data-summary-type]');
    const sumNeedEl   = modal.querySelector('[data-summary-needed]');

    const scheduleBox = modal.querySelector('[data-schedule]');
    const scheduleBtn = modal.querySelector('[data-schedule-toggle]');
    const scheduleBody= modal.querySelector('[data-schedule-body]');

    let selectedOption = 'inperson'; // default like mock
    let groupedByDate = new Map();
    let selectedDateKey = null;
    let selectedSlot = null;

    const productForm =
      document.querySelector(`#add-to-cart-${sectionId} form`) ||
      document.querySelector('form[action*="/cart/add"]');

    const currentVariantId = () =>
      (productForm?.querySelector('[name="id"]')?.value) ||
      btn?.dataset.variantId || null;

    function currentVariantDetails(){
      const id = currentVariantId();
      if (!id) return null;
      return (window.BEYO_VMAP?.[sectionId] && window.BEYO_VMAP[sectionId][String(id)]) || null;
    }

    function ensureInBody(){
      if (!modal.dataset.movedToBody){
        document.body.appendChild(modal);
        modal.dataset.movedToBody = '1';
      }
    }

    function openModal(){
      ensureInBody();
      modal.hidden = false;
      document.documentElement.classList.add('beyo2-no-scroll');
      document.body.classList.add('beyo2-no-scroll');
    }

    function closeModal(){
      modal.hidden = true;
      document.documentElement.classList.remove('beyo2-no-scroll');
      document.body.classList.remove('beyo2-no-scroll');
    }

    function setBusy(isBusy){
      if (!confirmBtn) return;
      if (isBusy){
        confirmBtn.classList.add('is-busy');
        confirmBtn.setAttribute('aria-busy', 'true');
        confirmBtn.disabled = true;
        modal.querySelectorAll('input, .beyo2-slot, .beyo2-datechip').forEach(el => {
          if ('disabled' in el) el.disabled = true;
        });
      } else {
        confirmBtn.classList.remove('is-busy');
        confirmBtn.removeAttribute('aria-busy');
        modal.querySelectorAll('input, .beyo2-slot, .beyo2-datechip').forEach(el => {
          if ('disabled' in el) el.disabled = false;
        });
        updateSummary(); // recalculates disabled state
      }
    }

    // Help pop only by click, closes by X
    helpBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      helpPop?.classList.add('is-open');
    });
    helpClose?.addEventListener('click', (e) => {
      e.stopPropagation();
      helpPop?.classList.remove('is-open');
    });

    // close modal
    modal.addEventListener('click', e => { if (e.target.matches('[data-close]')) closeModal(); });
    document.addEventListener('keydown', e => { if (!modal.hidden && e.key === 'Escape') closeModal(); });

    // schedule accordion
    function setScheduleCollapsed(collapsed){
      if (!scheduleBox) return;
      scheduleBox.classList.toggle('is-collapsed', collapsed);
    }
    scheduleBtn?.addEventListener('click', () => {
      if (window.matchMedia('(min-width: 900px)').matches) return;
      setScheduleCollapsed(!scheduleBox.classList.contains('is-collapsed'));
    });

    function setOption(option){
      selectedOption = option;

      [optionInPerson, optionVideo, optionSimple].forEach(el => {
        if (!el) return;
        el.classList.toggle('beyo2-method--selected', el.dataset.option === option);
      });

      // schedule optional/required hint (visual)
      if (scheduleBody){
        scheduleBody.style.opacity = (option === 'simple') ? '0.55' : '';
      }

      // ✅ AUTO OPEN/CLOSE SCHEDULE
      const wantsSlot = (option === 'inperson' || option === 'video');

      // На мобилке: inperson/video -> открыть, simple -> закрыть
      if (window.matchMedia('(max-width: 899px)').matches) {
        setScheduleCollapsed(!wantsSlot);
      } else {
        // На десктопе можно не трогать (или тоже управлять — по желанию)
        // setScheduleCollapsed(false);
      }

      updateSummary();
    }

    optionInPerson?.addEventListener('click', () => setOption('inperson'));
    optionVideo?.addEventListener('click', () => setOption('video'));
    optionSimple?.addEventListener('click', () => setOption('simple'));

    // input changes update summary
    modal.addEventListener('input', (e) => {
      if (e.target && e.target.matches('input')) updateSummary();
    });

    function calc24hRange(){
      const now = new Date();
      const to  = new Date(now.getTime() + 24*60*60*1000);
      return { from: now, to: to };
    }

    async function loadTimesNext24h(){
      const { from, to } = calc24hRange();
      const reqFrom = ymd(from);
      const reqTo   = ymd(to);

      groupedByDate.clear();
      selectedDateKey = null;
      selectedSlot = null;

      datesWrap.innerHTML = '';
      slotsList.innerHTML = '';
      emptyEl.hidden = true;

      const res = await fetch(API_BASE + '/api/public/timeslots', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ from: reqFrom, to: reqTo })
      });

      if (!res.ok) return;

      const items = await res.json().catch(() => []);
      for (const it of items){
        if (!it?.date || !it?.startTime || !(it.available > 0)) continue;
        const dt = toLocalIso(it.date, it.startTime);
        if (!groupedByDate.has(it.date)) groupedByDate.set(it.date, []);
        groupedByDate.get(it.date).push({ start: it.startTime, duration: it.durationMinutes, dt });
      }

      for (const [k, arr] of groupedByDate.entries()){
        arr.sort((a,b) => a.dt - b.dt);
      }
    }

    function renderDateChips(){
      datesWrap.innerHTML = '';
      const keys = [...groupedByDate.keys()].sort();

      if (!keys.length){
        slotsList.innerHTML = '';
        emptyEl.hidden = false;
        return;
      }

      for (const k of keys){
        const d = new Date(k + 'T00:00:00');
        const label = d.toLocaleDateString(undefined, { weekday:'short', day:'2-digit', month:'short' });
        const b = document.createElement('button');
        b.type='button';
        b.className='beyo2-datechip';
        b.textContent = label;
        b.dataset.date = k;
        b.addEventListener('click', () => selectDate(k, b));
        datesWrap.appendChild(b);
      }

      const first = datesWrap.querySelector('.beyo2-datechip');
      if (first) selectDate(first.dataset.date, first);
    }

    function selectDate(key, el){
      [...datesWrap.querySelectorAll('.beyo2-datechip')].forEach(x => x.classList.remove('beyo2-datechip--sel'));
      el.classList.add('beyo2-datechip--sel');
      selectedDateKey = key;
      selectedSlot = null;
      renderSlotsForDate(key);
      updateSummary();
    }

    function renderSlotsForDate(key){
      const rows = groupedByDate.get(key) || [];
      slotsList.innerHTML = '';
      emptyEl.hidden = rows.length > 0;

      for (const r of rows){
        const b = document.createElement('button');
        b.type='button';
        b.className='beyo2-slot';
        b.textContent = r.dt.toLocaleTimeString([], { hour:'2-digit', minute:'2-digit' });
        b.addEventListener('click', () => {
          [...slotsList.querySelectorAll('.beyo2-slot')].forEach(x => x.classList.remove('beyo2-slot--sel'));
          b.classList.add('beyo2-slot--sel');
          selectedSlot = { start: r.start, duration: r.duration };
          updateSummary();
        });
        slotsList.appendChild(b);
      }
    }

    function isFieldOk(sel){
      const v = (modal.querySelector(sel)?.value || '').trim();
      return v.length > 0;
    }

    function updateSummary(){
      const sumNeedRow = sumNeedEl?.closest('.beyo2-srow');
      const typeText =
        selectedOption === 'simple' ? 'Simple 24-Hour Reservation' :
        selectedOption === 'inperson' ? 'Reservation + In-Person Viewing' :
        'Reservation + Video Call';

      if (sumTypeEl) sumTypeEl.textContent = typeText;

      // показываем Date/Time только для inperson/video
      const needsSlot = (selectedOption === 'inperson' || selectedOption === 'video');
      if (sumWhenEl) sumWhenEl.hidden = !needsSlot;

      if (needsSlot){
        // Date
        if (sumDateEl){
          sumDateEl.textContent = selectedDateKey
            ? new Date(selectedDateKey + 'T00:00:00').toLocaleDateString(undefined, { weekday:'short', day:'2-digit', month:'short' })
            : 'Not selected';
          sumDateEl.style.color = selectedDateKey ? '' : '#ef4444';
        }

        // Time
        if (sumTimeEl){
          sumTimeEl.textContent = selectedSlot ? selectedSlot.start : 'Not selected';
          sumTimeEl.style.color = selectedSlot ? '' : '#ef4444';
        }
      }

      // required fields
      const missing = [];
      if (!isFieldOk('[name="firstName"]')) missing.push('Complete all required fields');
      if (!isFieldOk('[name="lastName"]'))  missing.push('Complete all required fields');
      if (!isFieldOk('[name="email"]'))     missing.push('Complete all required fields');
      if (!isFieldOk('[name="phone"]'))     missing.push('Complete all required fields');

      // уберём дубли если несколько полей пустые
      const uniqMissing = [...new Set(missing)];

      if (needsSlot && (!selectedDateKey || !selectedSlot)){
        uniqMissing.push('Select date and time');
      }

      const ok = uniqMissing.length === 0;

      if (sumNeedRow){
        if (ok){
          // всё заполнено — убираем весь блок
          sumNeedRow.hidden = true;
        } else {
          sumNeedRow.hidden = false;
          sumNeedEl.innerHTML = uniqMissing.map(x => `• ${x}`).join('<br>');
          sumNeedEl.style.color = '#ef4444';
        }
      }
      if (confirmLabel){
        confirmLabel.textContent = ok ? 'Confirm Reservation' : 'Complete Required Fields';
      }

      if (confirmBtn) confirmBtn.disabled = !ok;
    }

    // localization success
    const successTexts = {
      ru: 'Ваша заявка принята, спасибо!',
      sv: 'Din förfrågan har tagits emot, tack!',
      en: 'Your request has been received. Thank you!'
    };
    function successText(){ return successTexts[LANG] || successTexts.en; }

    // analytics helper
    function track(type){
      fetch(API_BASE + '/api/analytics/track', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          type,
          shopDomain:(window.Shopify&&Shopify.shop)||location.host,
          pageUrl:location.href, referrer:document.referrer||'',
          sessionId:(localStorage.beyo_sid ||= Math.random().toString(36).slice(2)),
          productId:String(productId || ''),
          variantId:String(currentVariantId()||'')
        })
      }).catch(()=>{});
    }

    // open
    btn?.addEventListener('click', async (e) => {
      e.preventDefault();
      const v = currentVariantId();
      if (!v) return;

      track('reserve_click');

      openModal();

      // mobile: collapsed by default
      setScheduleCollapsed(window.matchMedia('(max-width: 899px)').matches);

      setOption('inperson');

      await loadTimesNext24h();
      renderDateChips();
      updateSummary();
    });

    // confirm
    confirmBtn?.addEventListener('click', async () => {
      if (confirmBtn.disabled || confirmBtn.classList.contains('is-busy')) return;

      msgEl.hidden = true;
      msgEl.textContent = '';

      setBusy(true);

      const firstName = modal.querySelector('[name="firstName"]').value.trim();
      const lastName  = modal.querySelector('[name="lastName"]').value.trim();
      const email     = modal.querySelector('[name="email"]').value.trim();
      const phone     = modal.querySelector('[name="phone"]').value.trim();

      const vInfo = currentVariantDetails();
      const isSimple = (selectedOption === 'simple');
      const isVideo  = (selectedOption === 'video');

      const payload = {
        FullName: (firstName + ' ' + lastName).trim(),
        Email: email || null,
        Phone: phone || null,
        Comment: 'Reserve via storefront',
        Language: LANG,
        IsLegalEntity: null,
        CompanyName: null,
        INN: null,
        ContactPerson: null,

        SimpleReservation: isSimple,
        IsVideoCall: isVideo,
        Date: isSimple ? null : selectedDateKey,
        StartTime: isSimple ? null : (selectedSlot?.start || null),
        DurationMinutes: isSimple ? 0 : (selectedSlot?.duration || 0),

        SellerUserId: null,
        ProductId: String(productId || ''),
        VariantId: String(currentVariantId() || ''),

        Products: vInfo ? [{
          ShopifyId: String(currentVariantId() || ''),
          SKU: vInfo.sku || null,
          Barcode: vInfo.barcode || null,
          Price: (vInfo.price ?? null),
          ProductUrl: (vInfo.variantUrl || vInfo.productUrl || null),
          Sold: false
        }] : []
      };

      track('reserve_submit');

      try {
        const r = await fetch(API_BASE + '/api/public/bookings', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify(payload)
        });
        if (!r.ok) throw new Error('HTTP ' + r.status);

        closeModal();
        showToast(successText());
      } catch (err) {
        console.error(err);
        msgEl.hidden = false;
        msgEl.style.color = 'crimson';
        msgEl.textContent = 'Failed to create reservation. Please try again.';
        setBusy(false);
      }
    });
  }

  // init all modals on page
  function initAll(){
    document.querySelectorAll('.beyo2-modal[data-beyo-reserve="v3"]').forEach(initModal);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
